export default "__VITE_ASSET__ocx0Uyd1__"